exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-1ca48574],.fade-leave-active[data-v-1ca48574]{transition:opacity .5s}.fade-enter[data-v-1ca48574],.fade-leave-to[data-v-1ca48574]{opacity:0}", ""]);

// exports
